<template>
	<button class="rc-btn">
		<slot></slot>
	</button>
</template>
<script>
export default {
	name: 'rc-button',

}
</script>
<style scoped>
header .rc-btn {
	font-size: 1rem;
	padding: .5rem;
	background: #004080;
	border: 1px solid #FFFFFF;
	border-radius: 2px;
	color: #FFFFFF;
}
</style>